import { FC } from 'react';
import NavCommon from '../../Teaser/NavCommon';
import { useMembersStore } from '../../../MembersProvider';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { EU_SITES, NA_SITES } from '@/constants/membersday';

interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { secKillProduct } = useMembersStore();

    let navList: { title: string; href: string }[] = [
        {
            title: t('nav_title_1'),
            href: 'activity-eco-redeem-rewards',
        },
    ];

    if (EU_SITES.includes(locale)) {
        navList = [
            {
                title: t('nav_title_1'),
                href: 'activity-eco-redeem-rewards',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_4'),
                href: 'activity-Accessories',
            },
            {
                title: t('nav_title_5'),
                href: 'activity-Extra-Batteries',
            },
            {
                title: t('nav_title_6'),
                href: 'teaser-JoinUs',
            },
            {
                title: t('nav_title_7'),
                href: 'teaser-ReferralNext',
            },
        ];
    }

    if (NA_SITES.includes(locale)) {
        navList = [
            {
                title: t('nav_title_1'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-BestSellers',
            },
            {
                title: t('nav_title_4'),
                href: 'activity-Accessories',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_5'),
                href: 'teaser-JoinUs',
            },
        ];
    }

    if (locale === 'au') {
        navList = [
            {
                title: t('nav_title_1'),
                href: 'teaser-CelebratingUs',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_3'),
                href: 'teaser-JoinUs',
            },
            {
                title: t('nav_title_4'),
                href: 'teaser-ReferralNext',
            },
            {
                title: t('nav_title_5'),
                href: 'teaser-EcoBenefits',
            },
        ];
    }

    if (locale === 'kr') {
        navList = [
            {
                title: t('nav_title_1'),
                href: 'teaser-CelebratingUs',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-BestSellers',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_4'),
                href: 'teaser-ReferralNext',
            },
        ];
    }

    if (locale === 'za') {
        navList = [
            {
                title: t('nav_title_1'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-Accessories',
            },
            {
                title: t('nav_title_4'),
                href: 'teaser-JoinUs',
            },
            {
                title: t('nav_title_5'),
                href: 'teaser-ReferralNext',
            },
        ];
    }

    if (locale === 'jp') {
        navList = [
            {
                title: t('nav_title_1'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-HotBundles1',
            },
            {
                title: t('nav_title_4'),
                href: 'activity-BestSellers',
            },
            {
                title: t('nav_title_5'),
                href: 'teaser-JoinUs',
            },
        ];
    }

    // 如果 秒杀模块返回产品列表为空 则去掉秒杀导航
    const flashSaleIndex = navList.findIndex((item) => item.href === 'activity-FlashSale');
    if (flashSaleIndex > -1 && secKillProduct && secKillProduct.length === 0) navList.splice(flashSaleIndex, 1);

    return (
        <>
            <NavCommon list={navList} />
        </>
    );
};

export default Banner;
